import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontIcon } from '@fluentui/react/lib/Icon';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal
} from "@azure/msal-react";
import { IPublicClientApplication } from "@azure/msal-browser";
import { useLanguage, Lang } from 'contexts/LanguageContext';
import { useSubscription } from 'contexts/SubscriptionContext';

const iconClass = mergeStyles({
  fontSize: 18,
  height: 18,
  width: 18,
  margin: "-5px 5px 0 0",
});

interface DesktopNavProps {
  language: Lang;
  pathParts: string[];
  signInClickHandler: (instance: IPublicClientApplication) => void;
  signOutClickHandler: (instance: IPublicClientApplication) => void;
}

export default function DesktopNav({
  language,
  pathParts,
  signInClickHandler,
  signOutClickHandler
}: DesktopNavProps) {
  const [connectNavOpen, setConnectNavOpen] = useState(false);
  const { instance } = useMsal();
  const langArr: Lang[] = ["fr", "en"];
  const { onLanguageChange, res } = useLanguage();

  function generateLangLink(newLang: Lang, langArr: Lang[], pathParts: string[]): string {
    if (langArr.includes(pathParts[0] as Lang)) {
      pathParts[0] = newLang; // If the path starts with a language code, replace it
    } else {
      pathParts.unshift(newLang); // If the path doesn't start with a language code, add the new language at the beginning
    }

    return '/' + pathParts.join('/');
  }

  function WelcomeUser() {
    const { accounts } = useMsal()
    let userName: string | unknown = (accounts[0] && accounts[0].name) ? accounts[0].name.split(" ")[0] : ""

    if (userName === "" || userName === "unknown") {
      userName = (accounts[0] && accounts[0].idTokenClaims) ? accounts[0].idTokenClaims.given_name : ""
    }

    // const userEmail = (accounts[0] && accounts[0].username) ? accounts[0].username : ""
    // possible link to display the user account: href={"https://myaccount.microsoft.com/?ref=MeControl&login_hint="+userEmail}

    return (
      <>
        <button onClick={() => setConnectNavOpen(!connectNavOpen)}>{res.Bonjour} {(userName as string)}
          <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" style={{ display: "inline-block" }}>
            <path d={(connectNavOpen) ? "M18 15 12 9 6 15" : "M6 9L12 15 18 9"}></path>
          </svg>
        </button>
        {(connectNavOpen) ? (
          <nav
            className="submenu absolute right-0 z-20 overflow-hidden transition-all duration-300 ease-in-out"
          >
            <ul className="bg-gray-700 py-2 bb-1">
              <li>
                <Link to={res.pagesLinks['history']} reloadDocument={true}>{res.pagesMetadata.history.linkTitle}</Link>
              </li>
              <li>
                <button
                  onClick={() => { signOutClickHandler(instance); }}
                >
                  {res["Déconnexion"]}
                </button>
              </li>
            </ul>
          </nav>
        ) : null}
      </>
    )
  }

  return (
    <nav className="hidden md:flex md:grow">
      {/* Desktop navigation */}
      <ul className="flex grow justify-end flex-wrap items-center">
        <li>
          <Link
            to={res.pagesLinks['search']}
            reloadDocument={true}>
            {res.pagesMetadata.search.linkTitle}
          </Link>
        </li>

        <li>
          <Link to="https://talamus.pro/formations" target="_blank">
            <FontIcon aria-label="NavigateExternalInline" iconName="NavigateExternalInline" className={iconClass} />
            {res["Plans et abonnements"]}
          </Link>
        </li>

        <li className="relative">
          <AuthenticatedTemplate>
            {/* This will only render if a user is signed-in */}
            <WelcomeUser />
          </AuthenticatedTemplate>
          <UnauthenticatedTemplate>
            <Link to="#" onClick={(e) => {
              e.preventDefault();
              signInClickHandler(instance)
            }
            }>
              {res["Me connecter"]}
            </Link>
          </UnauthenticatedTemplate>
        </li>

        <li>
          <Link to={res.pagesLinks['subscribe']} reloadDocument={true}>{res.pagesMetadata.subscribe.linkTitle}</Link>
        </li>
        {langArr.map((linkLg: Lang, i, arr) => (
          <li key={"lg_" + linkLg}>
            <Link
              to={generateLangLink(linkLg, langArr, pathParts)}
              onClick={() => {
                if (onLanguageChange) {
                  onLanguageChange(linkLg);
                }
              }}
            >
              {linkLg.toUpperCase()}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
}